import BrokersApi from '../BrokersApi';
import * as ActionTypes from './ActionTypes';
import IBrokerListAgent from '../list/IBrokerListAgent';

function listSucceeded(result: IBrokerListAgent[]) {
    return { type: ActionTypes.LIST_BROKER_AGENT_SUCCESS, result: result };
}

export function list(): (dispatch: (result: any) => void, getState: any) => any {
    return function (dispatch: (result: any) => void, getState: any) {
        return BrokersApi.listBrokerAgent().then((result: IBrokerListAgent[]) => {
            dispatch(listSucceeded(result));
        });
    };
}

function deleteBrokerListAgentSuccess(result: IBrokerListAgent) {
    return { type: ActionTypes.DELETE_BROKER_LIST_AGENT_SUCCESS, result };
}

export function deleteBrokerListAgent(id: number) {
    return function (dispatch: (result: any) => void, getState: any) {
        return BrokersApi.deleteListBrokerAgent(id).then((result: IBrokerListAgent) => {
            dispatch(deleteBrokerListAgentSuccess(result));
        });
    };
}

function restoreBrokerListAgentSuccess(result: IBrokerListAgent) {
    return { type: ActionTypes.RESTORE_BROKER_LIST_AGENT_SUCCESS, result };
}

export function restoreBrokerListAgent(id: number) {
    return function (dispatch: (result: any) => void, getState: any) {
        return BrokersApi.restoreListBrokerAgent(id).then((result: IBrokerListAgent) => {
            dispatch(restoreBrokerListAgentSuccess(result));
        });
    };
}
